import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { RestUserService } from '@app/core/api/rest.user.service';

import { PayloadUtil } from '@app/core/util/payload.util';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { LoaderComponent } from '../../loader/loader.component';
import { TextSmallDirective } from '../../../core/directive/text-small.directive';
import { PeziButtonComponent } from '../../pezi-button/pezi-button.component';

@UntilDestroy()
@Component({
  selector:        'app-portal-information-dialog',
  templateUrl:     './portal-information-dialog.component.html',
  styleUrls:       ['./portal-information-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone:      true,
  imports:         [
    CdkScrollable,
    MatDialogContent,
    NgIf,
    LoaderComponent,
    TextSmallDirective,
    PeziButtonComponent,
    MatDialogActions,
    MatDialogClose
  ]
})
export class PortalInformationDialogComponent implements OnInit {

  public loadingRememberMeStatus: boolean;
  public rememberMeActive: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public isMakler: boolean,private restUserService: RestUserService, private cd: ChangeDetectorRef, private dialogRef: MatDialogRef<void>) {
  }

  ngOnInit(): void {

    this.restUserService.checkRememberMe()
      .pipe(
        take(1),
        untilDestroyed(this)
      )
      .subscribe(payload => {
        if (PayloadUtil.checkPayload(payload)) {
          this.rememberMeActive = true;
        }
        this.loadingRememberMeStatus = false;
        this.cd.markForCheck();
      });
  }

  public async rememberMe(): Promise<void> {
    const result = await firstValueFrom(this.restUserService.rememberMe());
    if (PayloadUtil.checkPayload(result)) {
      this.rememberMeActive = true;
      this.dialogRef.close();
    }
  }

}
